import theme from 'theme';

export const previewContainerStyles = {
    border: `2px solid ${theme.palette.primary.main}`,
    borderRadius: 4,
    height: '600px',
    display: 'flex',
    flexDirection: 'column',
};

export const previewHeaderStyles = {
    minHeight: 80,
    backgroundColor: 'action.hover',
    borderRadius: '16px 16px 0 0',
};

export const messageAreaStyles = {
    flexGrow: 1,
    backgroundColor: `${theme.palette.common.white}`,
    px: 2,
    py: 1,
    overflowY: 'auto',
    maxHeight: 'calc(100vh - 400px)',
};

export const messageDescriptorStyles = {
    color: '#3C3C4399',
    textAlign: 'center',
    mb: 1,
};

export const messageBubbleStyles = {
    borderRadius: '20px',
    p: 2,
    maxWidth: '75%',
    alignSelf: 'flex-start',
    position: 'relative',
    marginBottom: '10px',
};

const sharedMessageBubbleBeforeStyles = {
    // This creates the actual tail shape
    content: '""',
    position: 'absolute',
    zIndex: 0,
    bottom: 0,
    height: '20px',
    width: '20px',
};

const sharedMessageBubbleAfterStyles = {
    // This masks part of the tail to create the curved effect
    content: '""',
    position: 'absolute',
    zIndex: 1,
    bottom: 0,
    width: '10px',
    height: '20px',
};

export const sentMessageBubbleStyles = {
    backgroundColor: '#34C759',
    '&::before': {
        ...sharedMessageBubbleBeforeStyles,
        right: '-7px',
        backgroundColor: '#34C759',
        borderBottomLeftRadius: '15px',
    },
    '&::after': {
        ...sharedMessageBubbleAfterStyles,
        backgroundColor: `${theme.palette.common.white}`,
        right: '-10px',
        borderBottomLeftRadius: '10px',
    },
};

export const receivedMessageBubbleStyles = {
    backgroundColor: '#E5E5EA',
    '&::before': {
        ...sharedMessageBubbleBeforeStyles,
        left: '-7px',
        backgroundColor: '#E5E5EA',
        borderBottomRightRadius: '15px',
    },
    '&::after': {
        ...sharedMessageBubbleAfterStyles,
        left: '-10px',
        backgroundColor: `${theme.palette.common.white}`,
        borderBottomRightRadius: '10px',
    },
};

export const messageTextStyles = {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
    overflowWrap: 'break-word',
    width: '100%',
};

export const inputAreaStyles = {
    pointerEvents: 'none',
    p: 2,
    backgroundColor: `${theme.palette.common.white}`,
    alignItems: 'center',
    borderRadius: 4,
};

export const inputFieldStyles = {
    flex: 1,
    border: `0.5px solid #3C3C435C`,
    borderRadius: '30px',
    paddingLeft: 2,
    minHeight: '36px',
    alignItems: 'center',
    justifyContent: 'space-between',
};
